import { SpinnerIcon } from "@/assets/icons";

export const LoadingVerifyToken = () => (
  <div className="w-full h-screen flex justify-center items-center">
    <SpinnerIcon
      className="spin-animation"
      width={60}
      height={60}
      title="loading-spinner"
    />
  </div>
);

export default LoadingVerifyToken;
